import { render, staticRenderFns } from "./SequenceWorkspace.vue?vue&type=template&id=0268f8be&scoped=true&"
import script from "./SequenceWorkspace.vue?vue&type=script&lang=js&"
export * from "./SequenceWorkspace.vue?vue&type=script&lang=js&"
import style0 from "./SequenceWorkspace.vue?vue&type=style&index=0&id=0268f8be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0268f8be",
  null
  
)

export default component.exports